import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, timeout: 180000 });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("vita_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // expired/invalid: drop token
      localStorage.removeItem("vita_token");
    }
    return Promise.reject(err);
  }
);

export default api;
